var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNopolicies(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 186,
    viewBox: "0 0 174 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.585 126.262C163.565 123.779 165.115 123.167 167.928 124.578C168.316 124.773 168.484 125.131 168.908 124.868C169.279 124.639 169.515 124.533 169.939 124.518",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.568 13.767C157.064 49.2911 159.933 121.493 159.435 126.107L165.338 144.098L170.231 125.736L168.688 13.3154C162.672 -8.80824 157.435 4.39828 155.568 13.767Z",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.401 14.5391C159.658 15.7969 164.129 15.2859 168.513 15.135",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.34 16.2732C159.186 40.827 160.553 65.3317 161.398 89.8831C161.514 93.2633 161.631 96.6435 161.747 100.024C161.816 102.019 161.884 104.014 161.953 106.009C162.018 107.901 162.559 109.62 162.666 111.512C162.906 115.751 163.512 128.472 163.366 124.229",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.525 16.1292C164.16 19.0462 163.801 22.7755 163.913 26.0304C164.035 29.5849 164.157 33.1394 164.28 36.6939C164.452 41.7109 164.625 46.7279 164.798 51.7449C165.02 58.2002 165.242 64.6555 165.465 71.1108C165.524 72.8429 165.84 74.8678 165.478 76.5648C165.131 78.1891 164.706 79.5102 164.764 81.1856C164.839 83.3648 164.914 85.544 164.989 87.7232C165.116 91.4037 165.243 95.0841 165.369 98.7645C165.514 102.979 165.618 107.566 166.395 111.674C166.845 114.047 167.02 116.303 167.104 118.734C167.135 119.628 166.753 123.978 167.559 124.347",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2211 68.5467C7.29477 60.0857 4.54477 51.6818 2.56541 42.9683C0.805903 35.2225 1.02262 33.0859 10.2858 30.7075C34.2278 24.5599 59.1122 21.6301 83.1847 15.7677C87.6077 14.6905 92.0233 13.6492 96.5011 12.8013C97.2485 12.6597 100.367 11.6724 101.27 12.3925C105.639 15.8788 105.255 24.8965 106.014 29.5731C107.609 39.3973 112.263 48.2533 114.898 57.8136C119.095 73.0376 123.062 88.3588 126.597 103.735C129.481 116.283 132.362 128.712 134.093 141.468C134.716 146.053 135.338 150.638 135.96 155.222C136.279 157.569 137.391 160.912 136.912 163.341C136.55 165.176 127.314 166.816 125.97 167.144C112.689 170.38 99.009 172.644 85.561 175.151C74.7864 177.16 64.0985 179.019 53.2324 180.494C48.3915 181.151 43.8259 182.022 39.0617 182.997C36.3625 183.549 33.6878 184.636 32.7471 182.014C29.3448 172.53 29.1975 163.361 27.8684 153.57C27.2279 148.852 26.5874 144.133 25.9469 139.415C25.3316 134.882 23.4398 130.941 22.8157 126.343C21.5253 116.838 21.0228 106.744 18.5577 97.475C16.6162 90.1749 14.2848 83.3988 11.9503 76.2871",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1724 73.6524C13.8081 68.7368 14.4879 62.9744 16.8772 58.0127C19.3779 52.8194 23.4701 61.8742 24.7604 64.0201C25.6407 65.4842 29.6346 74.1064 32.1493 74.1337C33.5397 74.1488 33.5478 68.8357 35.7415 68.2845C38.3418 67.6312 40.3187 66.8242 42.6018 65.3641C44.6069 64.0818 48.881 63.4995 51.2342 63.4781C56.2484 63.4325 59.7127 60.6484 64.4585 59.6115",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7744 128.229C47.7744 114.361 47.7744 100.493 47.7744 86.6244C47.7744 85.9636 47.793 83.9908 47.8865 84.645C48.6569 90.038 49.629 95.4053 50.7248 100.742C51.9394 106.656 52.2724 106.583 56.7004 103.841C59.0936 102.36 60.1056 107.253 62.3398 107.389C64.872 107.544 66.8547 105.846 68.6141 104.327C69.4362 103.617 71.25 104.095 72.2368 103.991C73.8813 103.818 73.7548 102.929 75.7847 103.393C79.3961 104.219 81.1086 103.344 83.4035 100.667",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7568 144.293C68.3849 136.969 90.2258 136.401 110.59 131.609",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.228 149.047C54.9461 148.37 61.6261 147.327 68.3107 146.405",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7568 154.859C66.0348 152.404 83.5314 149.802 100.549 145.875",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8145 164.903C60.8811 161.998 72.2737 161.903 83.1094 158.033",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopolicies);
export default __webpack_public_path__ + "static/media/nopolicies.960cc6fc15e718366da2bd8f9cbe8da3.svg";
export { ForwardRef as ReactComponent };